import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Stack,
} from '@mui/material';

const EmbryoFreezingTable = ({
  notifications,
  getCellData,
  setModalOpen,
  handleResendNotification,
  handleDeleteNotification,
  emptyModalState,
}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Patient Name</strong>
            </TableCell>
            <TableCell>
              <strong>MPID</strong>
            </TableCell>
            <TableCell>
              <strong>Mobile Number</strong>
            </TableCell>
            <TableCell>
              <strong>Spouse Name</strong>
            </TableCell>
            <TableCell>
              <strong>Freezing Duration</strong>
            </TableCell>
            <TableCell>
              <strong>Date of Expiry</strong>
            </TableCell>

            <TableCell>
              <strong>Remaining Cryo-Device</strong>
            </TableCell>

            <TableCell>
              <strong>Remaining Embryos/Oocyte</strong>
            </TableCell>
            <TableCell>
              <strong>Number of Notifications Sent</strong>
            </TableCell>
            <TableCell>
              <strong>Last Notification</strong>
            </TableCell>
            <TableCell>
              <strong>Actions</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {notifications.notifications.map((notification) => (
            <TableRow key={notification.id}>
              <TableCell>{getCellData(notification, 'patientName')}</TableCell>
              <TableCell>{getCellData(notification, 'patient.upid')}</TableCell>
              <TableCell>
                {getCellData(notification, 'patient.phone')}
              </TableCell>
              <TableCell>{getCellData(notification, 'spouseName')}</TableCell>
              <TableCell>
                {getCellData(notification, 'embryo.freezingDuration')}
              </TableCell>
              <TableCell>
                {getCellData(notification, 'embryo.dateOfExpiry')}
              </TableCell>
              <TableCell>
                {getCellData(notification, 'embryo.remainingCryoDevice')}
              </TableCell>
              <TableCell>
                {getCellData(notification, 'embryo.remainingEmbryos')}
              </TableCell>
              <TableCell>
                {getCellData(notification, 'countOfNotificationsSent')}
              </TableCell>
              <TableCell>
                {getCellData(notification, 'lastNotificationSentAt')}
              </TableCell>
              <TableCell>
                {notification.isNotificationRemoved ? (
                  <>
                    {getCellData(notification, 'notificationDeletionComments')}
                  </>
                ) : (
                  <Stack direction="row" spacing={2}>
                    <IconButton
                      onClick={() => {
                        setModalOpen({
                          open: true,
                          title: 'Resend Notification',
                          body: 'Are you sure you want to resend the notification?',
                          proceedText: 'Resend',
                          cancelText: 'Cancel',
                          needsComments: false,
                          onSave: () => handleResendNotification(notification),

                          onClose: () => setModalOpen({ ...emptyModalState }),
                        });
                      }}
                      color="primary"
                      aria-label="resend"
                    >
                      <i className="fa fa-envelope"></i>
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setModalOpen({
                          open: true,
                          title: 'Delete Notification',
                          body: 'Enter reason for deletion',
                          proceedText: 'Delete',
                          cancelText: 'Cancel',
                          needsComments: true,
                          onSave: handleDeleteNotification,
                          notification: notification,
                          onClose: () => {
                            setModalOpen({ ...emptyModalState });
                          },
                        });
                      }}
                      color="secondary"
                      aria-label="delete"
                    >
                      <i className="fa fa-trash"></i>
                    </IconButton>
                  </Stack>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EmbryoFreezingTable;
